import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// NEW project's Firebase web config — set REACT_APP_FIREBASE_* in client/.env
// (the original elitereals-app config must never be used here)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ""
};

let app = null;
let analytics = null;
let auth = null;

if (firebaseConfig.apiKey) {
  app = initializeApp(firebaseConfig);
  try { analytics = getAnalytics(app); } catch (e) { /* analytics optional */ }
  auth = getAuth(app);

  // Only for automated/local testing with Firebase console "test phone
  // numbers" — breaks real SMS delivery, so it must be opted into.
  if (window.location.hostname === 'localhost' && process.env.REACT_APP_FIREBASE_TEST_MODE === 'true') {
    auth.settings.appVerificationDisabledForTesting = true;
  }
} else {
  console.warn('[firebase] REACT_APP_FIREBASE_* not configured — phone verification and analytics disabled');
}

export { app, analytics, auth };
